import type { TAgreementLinkState } from '../../reducers/agreementLink';
import type { IApplicationState } from '../../types/redux';

export const selectAgreementLink = (state: IApplicationState): TAgreementLinkState => {
  return state.agreementLink;
};
